import { Route } from 'react-router';
import { Maintenance } from './Maintenance';
import React, { FC, ReactNode } from 'react';
import { Routes } from 'react-router-dom';

export const MaintenanceWrapper: FC<{ active: boolean; children: ReactNode }> = ({ active, children }) => {
    if (active) {
        return <Maintenance />;
    }

    return (
        <Routes>
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="*" element={children} />
        </Routes>
    );
};
